import { createAsyncThunk } from '@reduxjs/toolkit';
import baseURL from '../utils/baseURL';
import useAxiosAuth from '../hooks/useAxiosAuth';

// One assistant turn. Identity is derived from the JWT on the backend — the
// widget only sends the text and a session id. Returns { reply, session_id }.
export const sendAssistantMessage = createAsyncThunk(
    'assistant/sendMessage',
    async ({ message, sessionId, surface = 'widget', replyLang }, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            // replyLang is the assistant's own language selection. The backend
            // ignores it for any surface other than the widget, so a choice made
            // in the chat bubble cannot change how AI Reports reads.
            const response = await axiosInstance.post(`${baseURL}/assistant/chat`, { message, sessionId, surface, replyLang });
            return response.data?.data || null;
        } catch (error) {
            return rejectWithValue(error?.response?.data || { message: 'Assistant unavailable' });
        }
    }
);

// Mic clip → text (backend proxies to the AI's Whisper STT). Returns { text }.
export const sendAssistantVoice = createAsyncThunk(
    'assistant/sendVoice',
    async ({ blob, language }, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const form = new FormData();
            form.append('audio', blob, 'voice.webm');
            // Which language the speaker is using. Left out, Whisper guesses and
            // returns Tamil speech written in English.
            if (language && language !== 'auto') form.append('language', language);
            const response = await axiosInstance.post(`${baseURL}/assistant/voice`, form, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            return response.data?.data || null;
        } catch (error) {
            return rejectWithValue(error?.response?.data || { message: 'Transcription failed' });
        }
    }
);
